//

const initialState = {
  quotedMessage: {},
};

export default function message(state = initialState, action) {
  switch (action.type) {
    case 'REPLY_TO_MESSAGE':
      return {
        quotedMessage: {
          ...state.quotedMessage,
          [action.threadId]: action.messageId,
        },
      };
    default:
      return state;
  }
}
